<template>
	<div class="footer">
		<div class="ft_con">
			<div class="lf d-flex flex-column j-center">
				<router-link to="/" class="ft_logo">
					<img src="@/assets/images/ft_logo.jpg" alt="" />
				</router-link>
				<div class="copy">
					<div>© CopyRight2024,Inc.AII Rights Reserverd</div>
					<div>联系方式：0312-6699303</div>
					<div><a href="https://beian.miit.gov.cn" target="_blank">冀ICP备2024097179号-1</a></div>
					<div>技术支持：<a href="https://www.hbdzwz.com" target="_blank">坤柔网络</a></div>
				</div>
			</div>
			<div class="cen d-flex">
				<dl class="flex-1">
					<dt class="d-flex a-center"><img src="@/assets/images/ft_ico2.png" class="ico" />农业服务</dt>
					<dd>
						<div><router-link to="/nongzi">农资服务</router-link></div>
						<div><router-link to="/nongji">农机服务</router-link></div>
					</dd>
				</dl>
				<dl class="flex-1">
					<dt class="d-flex a-center"><img src="@/assets/images/ft_ico2.png" class="ico" />金融服务</dt>
					<dd>
						<div><router-link to="/financial">惠农金融产品</router-link></div>
						<div><router-link to="/financial?class_id=108">农业保险</router-link></div>
					</dd>
				</dl>
				<dl class="flex-1">
					<dt class="d-flex a-center"><img src="@/assets/images/ft_ico3.png" class="ico" />农技服务</dt>
					<dd>
						<div><router-link to="/talent">专家咨询</router-link></div>
						<div><router-link to="/consult">互动咨询</router-link></div>
					</dd>
				</dl>
			</div>
			<div class="ri d-flex flex-column j-center a-end">
				<img src="@/assets/images/ft_ewm.png" class="ewm" />
				<p class="wz">扫一扫<br />进入手机版</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "pagination",

		data() {
			return {
				classList: [],
			}
		},
		created() {
			this.getClass()
		},
		methods: {
			getClass() {
				var that = this;
				that.$axios.post(that.$baseUrl.myfwClaList, {})
					.then(res => {
						if (res.code == 200) {
							that.classList = res.data
						} else {
							that.$toast(res.msg);
						}
					})
					.catch(error => {
						console.error(error)
					})

			},
		}
	}
</script>

<style lang="less">
	.footer {
		background: #389523;

		.ft_con {
			height: 260px;
			padding: 66px 0;
			width: 1440px;
			margin: 0 auto;

			.lf {
				width: 478px;
				border-right: #fff solid 1px;
				height: 260px;
				float: left;

				.ft_logo {
					display: block;
					width: 420px;
					height: 54px;
				}

				.copy {
					padding: 24px 0 0;
					line-height: 32px;
					color: #ebebeb;
					font-size: 18px;

					a {
						color: #ebebeb;

						&:hover {
							color: #fff;
							text-decoration: underline;
						}
					}
				}
			}

			.cen {
				width: 750px;
				float: left;
				padding: 0 0 0 50px;

				dl {
					dt {
						height: 60px;
						font-size: 26px;
						font-weight: bold;
						color: #fff;
						line-height: 40px;

						.ico {
							display: block;
							width: 40px;
							height: 40px;
							margin-right: 5px;
						}
					}

					dd {
						padding-top: 10px;
						padding-left: 45px;

						div {
							height: 40px;
							line-height: 2;
							font-size: 20px;
							color: #f4f4f4;

							a {
								color: #f4f4f4;

								&:hover {
									color: #fff;
									text-decoration: underline;
								}
							}
						}
					}
				}
			}

			.ri {
				float: right;
				width: 160px;
				border-left: #fff solid 1px;
				height: 260px;

				.ewm {
					width: 94px;
					height: 94px;
				}

				.wz {
					padding-top: 10px;
					width: 94px;
					text-align: center;
					color: #fff;
					line-height: 1.5;
					font-size: 18px;
				}
			}
		}
	}
</style>